import { M8PartnerClientDTO } from 'services/production/types';
import { getM8PartnerURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';
import { customFetch } from 'utils/http';

export const getTrialClients = async (): Promise<M8PartnerClientDTO[]> => {
  const fetchURL = getM8PartnerURL('getTrialClients');

  const response = await customFetch(fetchURL);

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.json();
};
